var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          staticClass: "lime mt-2 ml-2 mr-2",
          on: {
            click: function ($event) {
              return _vm.submit()
            },
          },
        },
        [_vm._v("Submit")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "icon-container" }, [
        _vm.isSaving
          ? _c(
              "span",
              [_c("v-icon", { staticClass: "spin" }, [_vm._v("sync")])],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.saveSuccess
          ? _c(
              "span",
              [
                _c("v-icon", { attrs: { color: "green" } }, [_vm._v("done")]),
                _vm._v(" "),
                _c("span", [_vm._v("Changes saved successfully")]),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }